/**
 * The GraphQL endpoint the app talks to. This is the photon federation
 * gateway rather than quark directly, so subgraphs beyond quark — fusion's
 * sales channels — are reachable through the same client.
 *
 * VITE_GRAPHQL_API_URL overrides it per deployment. The UAT/prod defaults are
 * left as-is so nothing regresses if the gateway is not yet published at those
 * hostnames; point the env var at the gateway to enable sales channels there.
 */
// const gatewayUrl = (fallback: string): string => import.meta.env?.VITE_GRAPHQL_API_URL || fallback

const environments = {
  production: {
    quark: {
      // url: gatewayUrl("https://api.three-shelves.com/graphql/")
      url: "https://api.three-shelves.com/graphql/"
    }
  },
  development: {
    quark: {
      // url: gatewayUrl("https://api-uat.three-shelves.com/graphql/")
      url: "https://api-uat.three-shelves.com/graphql/"
    }
  },
  local: {
    quark: {
      // url: gatewayUrl("http://localhost:4000/graphql")
      url: "https://api-uat.three-shelves.com/graphql/"
    }
  }
}
export default environments
